import React, { useEffect, useRef } from 'react';

/**
 * Hairline gradient bar across the top of the viewport tracking read
 * progress. Written straight to a CSS custom property inside rAF so React
 * never re-renders on scroll.
 */
const ScrollProgress: React.FC = () => {
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        let frame = 0;

        const update = () => {
            frame = 0;
            const el = ref.current;
            if (!el) return;
            const max = document.documentElement.scrollHeight - window.innerHeight;
            const ratio = max > 0 ? Math.min(window.scrollY / max, 1) : 0;
            el.style.setProperty('--progress', ratio.toFixed(4));
        };

        const onScroll = () => {
            if (!frame) frame = requestAnimationFrame(update);
        };

        update();
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        return () => {
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('resize', onScroll);
            cancelAnimationFrame(frame);
        };
    }, []);

    return (
        <div className="scroll-progress" aria-hidden="true">
            <div className="scroll-progress__bar" ref={ref} />
        </div>
    );
};

export default ScrollProgress;
